import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a88acc7755b8c00140b9f5e_1791464344709_ce8ec91c/settle/src/app/invoice-management/components/InvoiceContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a88acc7755b8c00140b9f5e_1791464344709_ce8ec91c/settle/src/components/AppLayout.tsx");
